import type { FontFamily } from "@/lib/api";

export function fontStack(font?: FontFamily | string, category?: string) {
  if (font && typeof font === "object") {
    const cat = font.category || "";
    const fallback =
      cat === "hand"
        ? "cursive, Georgia, serif"
        : cat === "serif" || cat === "display"
          ? "Georgia, serif"
          : "system-ui, sans-serif";
    return `"${font.name}", ${fallback}`;
  }
  const key = String(font || "").toLowerCase();
  const kind = String(category || "").toLowerCase();
  if (kind === "hand" || key.includes("caveat") || key.includes("kalam") || key.includes("dancing") || key.includes("patrick") || key.includes("handlee") || key.includes("shantell")) {
    return '"Caveat", cursive, Georgia, serif';
  }
  if (key.includes("sans") && !key.includes("cormorant")) return '"Source Sans 3", system-ui, sans-serif';
  if (key.includes("lora")) return '"Lora", Georgia, serif';
  if (key.includes("playfair")) return '"Playfair Display", Georgia, serif';
  if (key.includes("fraunces")) return '"Fraunces", Georgia, serif';
  if (key.includes("cormorant")) return '"Cormorant Garamond", Georgia, serif';
  if (kind === "sans") return "system-ui, sans-serif";
  return '"Source Serif 4", Georgia, serif';
}

export default function FontFaces({ fonts }: { fonts: FontFamily[] }) {
  const css = fonts
    .filter((row) => row.regular_url)
    .map((row) => {
      const bold = row.bold_url && row.bold_url !== row.regular_url
        ? `@font-face{font-family:"${row.name}";src:url("${row.bold_url}") format("truetype");font-weight:700;font-style:normal;font-display:swap;}`
        : "";
      return (
        `@font-face{font-family:"${row.name}";src:url("${row.regular_url}") format("truetype");font-weight:400;font-style:normal;font-display:swap;}` +
        bold
      );
    })
    .join("");
  if (!css) return null;
  return <style>{css}</style>;
}
